import React, { useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { LuArrowUpRight, LuGithub } from "react-icons/lu";
import CICD from "../assets/CICD.jpg";
import Fit from "../assets/Fit.jpg";
import Ecommerce from "../assets/Ecommerce.png";
import TaskManagement from "../assets/TaskManagement.jpg";
import SmartHome from "../assets/SmartHome.jpg";
import WeatherDashboard from "../assets/WeatherDH.png";
import FleetManagement from "../assets/tracking.png";
import facereco from "../assets/facereco.jpg";
import platreco from "../assets/platreco.jpeg";
import IAcyber from "../assets/IAcyber.png";
import cancerIA from "../assets/cancerIA.jpeg";
import IAtrach from "../assets/IAtrach.png";
import { Container, Reveal, Section, SectionHeader, Tag, TagList } from "./ui";

const categories = ["All", "Web", "Mobile", "IoT", "DevOps", "AI/ML"];

const projects = [
  {
    id: 1,
    title: "Fleet Management System",
    description:
      "Web-based fleet management system with real-time tracking, route optimization and maintenance scheduling.",
    category: "Web",
    technologies: ["React", "Node.js", "MongoDB", "Express"],
    image: FleetManagement,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 2,
    title: "E-Commerce Platform",
    description:
      "Full-stack e-commerce solution with payment integration, inventory management and an admin dashboard.",
    category: "Web",
    technologies: ["React", "Node.js", "MongoDB", "Stripe", "Redux"],
    image: Ecommerce,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 3,
    title: "Task Management App",
    description:
      "Cross-platform mobile app for task management with real-time sync, offline support and team collaboration.",
    category: "Mobile",
    technologies: ["React Native", "Firebase", "Redux", "Expo"],
    image: TaskManagement,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 4,
    title: "Smart Home System",
    description:
      "IoT home automation system with sensor integration, real-time monitoring and mobile app control.",
    category: "IoT",
    technologies: ["Arduino", "Raspberry Pi", "MQTT", "Node.js", "React"],
    image: SmartHome,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 5,
    title: "CI/CD Pipeline",
    description:
      "Automated deployment pipeline with Docker containerization, Kubernetes orchestration and full monitoring.",
    category: "DevOps",
    technologies: ["Docker", "Kubernetes", "Jenkins", "AWS", "Terraform"],
    image: CICD,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 6,
    title: "Weather Dashboard",
    description:
      "Real-time weather monitoring dashboard with data visualization, historical trends and a responsive design.",
    category: "Web",
    technologies: ["Vue.js", "React.js", "Spring Boot", "JEE", ".NET", "PostgreSQL", "SQL Server"],
    image: WeatherDashboard,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 7,
    title: "Fitness Tracker",
    description:
      "Mobile fitness tracking app with workout planning, progress monitoring and social sharing.",
    category: "Mobile",
    technologies: ["Flutter", "Firebase", "Google Fit API", "Charts"],
    image: Fit,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 8,
    title: "Face Recognition System",
    description:
      "Deep-learning face recognition for real-time identification, authentication and security applications.",
    category: "AI/ML",
    technologies: ["OpenCV", "TensorFlow", "Python", "Deep Learning", "Face-API", "NumPy"],
    image: facereco,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 9,
    title: "License Plate Recognition",
    description:
      "Automatic license plate recognition (ALPR) with OCR for vehicle identification and traffic monitoring.",
    category: "AI/ML",
    technologies: ["OpenCV", "Tesseract OCR", "YOLO", "Python", "TensorFlow", "Computer Vision"],
    image: platreco,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 10,
    title: "AI Cyber-Attack Detection",
    description:
      "Machine-learning intrusion detection that identifies and prevents cyber attacks through anomaly detection and pattern recognition.",
    category: "AI/ML",
    technologies: ["Scikit-learn", "Python", "Neural Networks", "Pandas", "Keras", "Security Analytics"],
    image: IAcyber,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 11,
    title: "Cancer Detection with AI",
    description:
      "Medical imaging system using convolutional neural networks to support early cancer detection and diagnosis.",
    category: "AI/ML",
    technologies: ["TensorFlow", "Keras", "CNN", "Python", "Medical Imaging", "PyTorch"],
    image: cancerIA,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
  {
    id: 12,
    title: "Street Trash Detection",
    description:
      "Computer vision system that detects and classifies litter in urban environments to support smart-city waste management.",
    category: "AI/ML",
    technologies: ["YOLO", "OpenCV", "TensorFlow", "Python", "Object Detection", "CNN"],
    image: IAtrach,
    github: "https://github.com/ussef11",
    live: "https://green-waste-api.vercel.app/",
  },
];

const MAX_TAGS = 4;

const Filters = styled(Reveal)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 40px;
`;

const FilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid
    ${({ $active }) => ($active ? "var(--color-ink)" : "var(--color-border-strong)")};
  background: ${({ $active }) => ($active ? "var(--color-ink)" : "var(--color-surface)")};
  color: ${({ $active }) => ($active ? "#fff" : "var(--color-text)")};
  font-size: 0.9375rem;
  font-weight: 500;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    border-color: var(--color-ink);
  }

  span {
    font-family: var(--font-mono);
    font-size: 0.75rem;
    opacity: 0.7;
  }
`;

const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled(motion.li)`
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: var(--color-border-strong);
    box-shadow: var(--shadow-md);
  }

  &:hover img {
    transform: scale(1.03);
  }
`;

const Thumb = styled.div`
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--color-bg-subtle);
  border-bottom: 1px solid var(--color-border);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s var(--ease-out);
  }
`;

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;

  h3 {
    font-size: 1.1875rem;
    margin-bottom: 8px;
  }

  p {
    flex: 1;
    font-size: 0.9375rem;
    color: var(--color-muted);
    margin-bottom: 20px;
  }
`;

const Category = styled.span`
  font-family: var(--font-mono);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-primary);
  margin-bottom: 8px;
`;

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-top: 1px solid var(--color-border);
`;

const CardLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 52px;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--color-ink);
  transition: color 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    color: var(--color-primary);
  }
`;

const IconLink = styled(CardLink)`
  justify-content: center;
  min-width: 44px;
  color: var(--color-muted);
`;

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const countFor = category =>
    category === "All"
      ? projects.length
      : projects.filter(p => p.category === category).length;

  const filteredProjects =
    activeFilter === "All"
      ? projects
      : projects.filter(project => project.category === activeFilter);

  return (
    <Section id="portfolio" $tone="subtle">
      <Container>
        <SectionHeader
          eyebrow="Selected work"
          title="Recent projects"
          lead="A selection of projects across AI/ML, web, mobile, IoT and DevOps, from computer-vision systems to production e-commerce platforms."
        />

        <Filters role="group" aria-label="Filter projects by category">
          {categories.map(category => (
            <FilterButton
              key={category}
              type="button"
              $active={activeFilter === category}
              aria-pressed={activeFilter === category}
              onClick={() => setActiveFilter(category)}
            >
              {category}
              <span aria-hidden="true">{countFor(category)}</span>
            </FilterButton>
          ))}
        </Filters>

        <Grid>
          <AnimatePresence mode="popLayout" initial={false}>
            {filteredProjects.map(project => {
              const extraTags = project.technologies.length - MAX_TAGS;
              return (
                <Card
                  key={project.id}
                  layout
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.98 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                >
                  <Thumb>
                    <img
                      src={project.image}
                      alt={`${project.title} preview`}
                      loading="lazy"
                    />
                  </Thumb>

                  <Body>
                    <Category>{project.category}</Category>
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <TagList aria-label="Technologies">
                      {project.technologies.slice(0, MAX_TAGS).map(tech => (
                        <Tag key={tech}>{tech}</Tag>
                      ))}
                      {extraTags > 0 && (
                        <Tag title={project.technologies.slice(MAX_TAGS).join(", ")}>
                          +{extraTags}
                        </Tag>
                      )}
                    </TagList>
                  </Body>

                  <CardFooter>
                    <CardLink
                      href={project.live}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View project
                      <LuArrowUpRight aria-hidden="true" />
                    </CardLink>
                    <IconLink
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${project.title} on GitHub`}
                    >
                      <LuGithub aria-hidden="true" />
                    </IconLink>
                  </CardFooter>
                </Card>
              );
            })}
          </AnimatePresence>
        </Grid>
      </Container>
    </Section>
  );
};

export default Portfolio;
